export default {
  pluralLowerCase: 'результати',
  download: 'Завантажити результат',
  sendToEmail: 'Надіслати на email',
  filter: 'Фільтрувати результати',
  hide: 'Сховати результати',
  cancel: 'Скасувати результати',
  searchByImage: 'Пошук за зображенням',
  searchResultsByImage: 'Пошук результатів за зображенням',
  similarTo: 'Схоже на',
  clearImageSearch: 'Очистити пошук за зображенням',
  clickToReplaceTheImage: 'Натисніть, щоб замінити зображення',
  uploadImageForSearch:
    'Завантажте зображення, і ми знайдемо результати завдань, що містять його або схожі на нього.'
};
